import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
    ordem?: string;
    descricao?: string;

};

type Action = {
    setOrdem: (codigo: string | undefined) => void,
    setDescricao: (descricao: string | undefined) => void,
    clearFilters: () => void
};

export const useItensChecklistEntregaListaFilters = create<State & Action>((set) => ({
    ordem: undefined,
    descricao: undefined,
    setOrdem: (ordem) => set({ ordem }),
    setDescricao: (descricao) => set({ descricao }),
    clearFilters: () => set({
        ordem: undefined,
        descricao: undefined,
    }),
}));

export const initialChecklistEntregaFiltersValues: State = {
    ordem: undefined,
    descricao: undefined,

}